export default __webpack_public_path__ + "static/media/467.1b454344.png";